import { CommonModule } from "@angular/common"
import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	booleanAttribute,
	ChangeDetectionStrategy,
} from "@angular/core"
import { FormsModule } from "@angular/forms"
import { COMMON_IMPORTS } from "../../common-imports"
import {
	ConfigDefinitions,
	ExtendedInputFormClass,
} from "@app/definitions/types"
import { EventsService } from "@app/services/events.service"
import { InputsService } from "@app/services/inputs.service"
import { StoreService } from "@app/services/store.service"
import { InArrayPipe } from "@app/utils/in-array.pipe"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { PreIconComponent } from "@app/utils/utils.component"

@Component({
	imports: [
		COMMON_IMPORTS,
		InArrayPipe,
		LangValPipe,
		CommonModule,
		FormsModule,
	],
	selector: "app-gen-input",
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./gen-input.component.html",
})
export class GenInputComponent extends ExtendedInputFormClass {
	@Input() type: string = "text" //any type OR textarea
	@Input() height: string = "auto"
	@Input({ transform: booleanAttribute }) isNumber: boolean = false
	@Input() searchStr: string = ""
	@Input() showPassword: boolean = false
	@Input({ transform: booleanAttribute }) numberKeyboard: boolean = false

	@ViewChild("elementEl") elementEl //the input element. used for focus
	constructor(
		protected eventsService: EventsService,
		private store: StoreService,
		private inputsService: InputsService
	) {
		super()
	}

	ngOnInit() {
		this.inputsService.loadVarsToInput(this)
		if (this.isNumber) {
			this.className += " input-number"
			this.type = "number"
			this.numberKeyboard = true
		}
	}

	focus(scrollToTop: boolean = false) {
		//called from parent. focuses the input (can also scroll into view)
		this.elementEl.nativeElement.focus()
		if (scrollToTop) {
			this.elementEl.nativeElement.scrollIntoView(true)
		}
	}

	async ngAfterViewInit() {
		//after view is loaded - deal with focus if needed
		if (this.autofocus && !this.eventsService.isTouch) {
			//if has focus and screen isn't touch - focus on input
			await this.store.timeout(50)
			this.elementEl.nativeElement.focus()
		}
	}

	onkeyup() {
		//emit keyup event to parent (nothing passed)
		this.keyupEvent.emit()
	}
	onchange() {
		//emit change to parent (nothing passed)
		this.changeEvent.emit()
	}
	handleClick() {
		if (this.isNumber) {
			this.elementEl.nativeElement.select()
		}
	}
}
